import { render, staticRenderFns } from "./transactionrecord.vue?vue&type=template&id=986d5c1e&scoped=true"
import script from "./transactionrecord.vue?vue&type=script&lang=js"
export * from "./transactionrecord.vue?vue&type=script&lang=js"
import style0 from "./transactionrecord.vue?vue&type=style&index=0&id=986d5c1e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986d5c1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('986d5c1e')) {
      api.createRecord('986d5c1e', component.options)
    } else {
      api.reload('986d5c1e', component.options)
    }
    module.hot.accept("./transactionrecord.vue?vue&type=template&id=986d5c1e&scoped=true", function () {
      api.rerender('986d5c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/orderDetail/transactionrecord.vue"
export default component.exports